module.exports = __webpack_public_path__ + "static/media/resultsGraphicPassed1.31798096.JPG";